import validation from '../../../utils/validation'

const providerInfoValidate = ($$values: any) => {
  let errors = {}

  const justRequired = [
    {
      fieldName: 'first_name',
      errorText: 'First name',
    },
    {
      fieldName: 'last_name',
      errorText: 'Last name',
    },
    {
      fieldName: 'street',
      errorText: 'Address',
    },
    {
      fieldName: 'city',
      errorText: 'City',
    },
    {
      fieldName: 'state',
      errorText: 'State',
    },
    {
      fieldName: 'name_to_send_payments_to',
      errorText: 'Payment recipients',
    },
    {
      fieldName: 'payment_preference',
      errorText: 'Payment preference',
    },
    {
      fieldName: 'bank',
      errorText: 'Bank name',
    },
    {
      fieldName: 'account_name',
      errorText: 'Name on account',
    },
    {
      fieldName: 'identification_file_front',
      errorText: 'Identification document',
    },
    {
      fieldName: 'identification_file_back',
      errorText: 'Identification document',
    },
  ]

  errors = Object.assign(errors, validation.requiredFields($$values, justRequired))

  errors = Object.assign(
    errors,
    validation.requiredValidEmail($$values, {
      fieldName: 'email',
      errorText: 'Email',
    }),
  )

  errors = Object.assign(
    errors,
    validation.requiredValidDOB($$values, {
      fieldName: 'date_of_birth',
      errorText: 'Date of birth',
    }),
  )

  errors = Object.assign(
    errors,
    validation.requiredValidPhone($$values, {
      fieldName: 'phone',
      errorText: 'Phone',
    }),
  )

  errors = Object.assign(
    errors,
    validation.requiredValidNumberOfLength(
      $$values,
      {
        fieldName: 'zip_code',
        errorText: 'Zipcode',
      },
      5,
    ),
  )

  errors = Object.assign(
    errors,
    validation.requiredValidNumberOfLength(
      $$values,
      {
        fieldName: 'ssn',
        errorText: 'Social security number',
      },
      9,
    ),
  )

  errors = Object.assign(
    errors,
    validation.requiredValidNumberOfLength(
      $$values,
      {
        fieldName: 'routing_number',
        errorText: 'Routing number',
      },
      9,
    ),
  )

  errors = Object.assign(
    errors,
    validation.requiredValidNumberOfLength(
      $$values,
      {
        fieldName: 'account_identifier',
        errorText: $$values.get('account_type') === 'individual' ? 'Social security number' : 'Identification number',
      },
      9,
    ),
  )

  errors = Object.assign(
    errors,
    validation.requiredValidNumber($$values, {
      fieldName: 'account_number',
      errorText: 'Account number',
    }),
  )

  return errors
}

export default providerInfoValidate
